import React from 'react';
import { HandlingTierSectionProps } from '../../types/bulkR2fTypes';
import { PendingThresholdChange } from '../../types/r2fTypes';
import { FCRow } from './FCRow';

/**
 * Component for displaying a handling tier section with collapsible warehouse rows
 */
export const HandlingTierSection: React.FC<HandlingTierSectionProps & {
    expandedWarehouses: Record<string, boolean>;
    shouldShowProductionCapability?: (pcName: string) => boolean;
}> = ({
    tierGroup,
    onToggleExpand,
    onValueChange,
    userCanEdit,
    pendingChanges,
    expandedWarehouses,
    shouldShowProductionCapability,
    invalidRows
}) => {
    return (
        <div className="handling-tier-section">
            <div className="tier-header">
                <h4 className="tier-name">{tierGroup.tierName}</h4>
                <span className="warehouse-count">
                    {tierGroup.warehouses.length} warehouse{tierGroup.warehouses.length !== 1 ? 's' : ''}
                </span>
            </div>
            
            {/* Shared Table Header */}
            <div className="shared-table-header">
                <div className="pc-table-header">
                    <div className="pc-name-col">Production Capability</div>
                    <div className="threshold-col">Low Threshold</div>
                    <div className="threshold-col">High Threshold</div>
                    <div className="meta-col">Last Updated</div>
                </div>
            </div>
            
            <div className="tier-content">
                {tierGroup.warehouses.map((warehouse) => (
                    <FCRow
                        key={warehouse.warehouseId}
                        warehouse={warehouse}
                        tierName={tierGroup.tierName}
                        onToggleExpand={onToggleExpand}
                        onValueChange={onValueChange}
                        userCanEdit={userCanEdit}
                        pendingChanges={pendingChanges}
                        isExpanded={expandedWarehouses[warehouse.warehouseId] || false}
                        shouldShowProductionCapability={shouldShowProductionCapability}
                        invalidRows={invalidRows}
                    />
                ))}
            </div>
        </div>
    );
};